import React, { Component } from 'react';

class Contacto extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [
                {
                    key: 1,
                    title: 'Si',
                    active: this.props.optionSelected ? true : false
                },
                {
                    key: 2,
                    title: 'No',
                    active: false
                }
            ]
        };
    }

    click(index, item) {
        for (var i in this.state.options) {
            this.state.options[i].active = false;
        }
        this.state.options[index].active = true;
        this.setState(this.state, () => this.props.callbackValue(item.title));

    }

    render() {
        const buttons = this.state.options.map((item, $index) => 
            <div className="survey-option" key={item.key} onClick={() => this.click($index, item)}>
                <i className={`survey-question-btn ${item.active? 'active' : ''}`}>
                    <i className="survey-question-btn-center"></i>
                </i>
                <span>{item.title}</span>
            </div>
        );
        return (
            <div className="survey-question">
                <div className="survey-question-subtext middle">¿NOS PODEMOS PONER EN CONTACTO CONTIGO PARA DARLE SEGUIMIENTO A TU COMENTARIO</div>
                <div className="survey-options middle">
                    {buttons}
                </div>
            </div>
        );
    }
}

export default Contacto;


// WEBPACK FOOTER //
// ./src/components/Contacto.js